/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Weight_BodyInputs */

const tr_katalog_desi_page_weight_body = /** @type {(inputs: Katalog_Desi_Page_Weight_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 desi yaklaşık 1 kilograma ve 3000 cm³ hacme denk gelir. Kargo ücreti; desi ile paketin gerçek ağırlığından hangisi büyükse ona göre belirlenir.`)
};

const en_katalog_desi_page_weight_body = /** @type {(inputs: Katalog_Desi_Page_Weight_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 desi equals roughly 1 kilogram and a volume of 3000 cm³. Shipping is charged on whichever is greater: the desi or the package's actual weight.`)
};

const de_katalog_desi_page_weight_body = /** @type {(inputs: Katalog_Desi_Page_Weight_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Desi entspricht etwa 1 Kilogramm und einem Volumen von 3000 cm³. Berechnet wird der Versand nach dem größeren Wert: Desi oder tatsächliches Paketgewicht.`)
};

const ru_katalog_desi_page_weight_body = /** @type {(inputs: Katalog_Desi_Page_Weight_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 деси примерно равен 1 килограмму и объёму 3000 см³. Доставка считается по большему значению: деси или фактический вес посылки.`)
};

/**
* | output |
* | --- |
* | "1 desi equals roughly 1 kilogram and a volume of 3000 cm³. Shipping is charged on whichever is greater: the desi or the package's actual weight." |
*
* @param {Katalog_Desi_Page_Weight_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_weight_body = /** @type {((inputs?: Katalog_Desi_Page_Weight_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Weight_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_weight_body(inputs)
	if (locale === "de") return de_katalog_desi_page_weight_body(inputs)
	if (locale === "ru") return ru_katalog_desi_page_weight_body(inputs)
	return tr_katalog_desi_page_weight_body(inputs)
});